import Component from './Component';

// window.runVideoStreamInit = '';
// let that = '';

export default class VideoStream extends Component {

  load() {
    // const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
    // let motion = 1;

    // if (!!isReduced) {
    //   // DON'T use an amination here!
    //   console.log('prefers-reduced-motion');
    //   motion = 0;
    // } else {
    //   // TODO: DO use an animation here!
    //   console.log('use motion');
    // }
    // that = this;
    this.vimeoLoad();
    super.load();
  }

  async vimeoLoad() {

    await waitForVariable(() => (typeof Vimeo === 'object'));

    // // if Vimeo ready first (from iframe) then run initVideoStream.
    // if ((typeof Vimeo === 'object')) {
    //   console.log('Vimeo ready in time.');
    //   this.initVideoStream();
    // }

    console.log('Vimeo ready in time.');
    this.initVideoStream();

    // if iframe onload occurs second then run initVideoStream .
    // window.runVideoStreamInit = function () {
    //   console.log('allow initVideoStream globally so it can be called later.');
    //   that.initVideoStream();
    // }

  }



  initVideoStream() {

    const iframe = document.querySelector('#vimeobgplayer');
    const vimplayer = new Vimeo.Player(iframe);

    // var player;
    const muteBtn = document.querySelector('.js-mute');
    const pauseBtn = document.querySelector('.js-pause');
    let manuallyMuted = false;
    const initiallyPauseVideo = document.querySelector('[data-videopaused]').dataset.videopaused;
    // console.log('initiallyPauseVideo:', initiallyPauseVideo);
    const videoForeground = document.querySelector('.video-foreground');
    // Vimeo player


    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


    // initiated by youtube query "enablejsapi=1"
    // function onYouTubeIframeAPIReady() {
    //   player = new YT.Player('youtubebanner', {
    //     playerVars: {
    //       autoplay: motion, // 1 Auto-play the video on load
    //       controls: 0, // Show pause/play buttons in player
    //       showinfo: 0, // Hide the video title
    //       modestbranding: 1, // 1 to hide the Youtube Logo
    //       loop: 1, // Run the video in a loop
    //       fs: 0, // Hide the full screen button
    //       cc_load_policy: 1, // Hide closed captions
    //       iv_load_policy: 3, // Hide the Video Annotations
    //       autohide: 1, // Hide video controls when playing
    //       rel: 0 // deprecated, Related videos from the channel will likely display
    //     },
    //     events: {
    //       'onReady': onPlayerReady,
    //       'onStateChange': onPlayerStateChange
    //     }
    //   });
    // }

    // function onPlayerReady() {
    //   console.log("hey Im ready");
    //   //do whatever you want here. Like, player.playVideo();
    //   player.mute(); // mute on start
    //   // player.playVideo(); // auto-play
    // }







    function play() {
      console.log('play');

      vimplayer.play().then(function () {
        // the video was played
        ;
      }).catch(function (error) {
        console.error('ERROR:', error);
      });

    }


    // Set listeners
    // document.addEventListener('mousemove', debounceAction);  // doesn't count as user interaction, can't autoplay with audio
    // document.addEventListener('scroll', debounceAction);  // doesn't count as user interaction, can't autoplay with audio
    videoForeground.addEventListener('click', debounceAction); // play

    muteBtn.addEventListener('click', (event) => {
      changeMute();
    });

    pauseBtn.addEventListener('click', (event) => {
      changePause();
    });



    let lastTime = Date.now();
    function debounceAction() {
      const nowTime = Date.now();
      if (nowTime - lastTime > 1000) {
        lastTime = nowTime; // reset the timer
        console.log('debounced mouse', lastTime, nowTime, (nowTime - lastTime));
        play();  // play
        if (manuallyMuted === false) {
          vimplayer.setMuted(false);  // unmute
        }
      }
    }



    let videoDuration = '';
    duration();
    async function duration() {
      const duration = await vimplayer.getDuration();
      videoDuration = duration;
    }



    function changeMute() {
      console.log('clicked mute button');

      vimplayer.getMuted().then(function (muted) {
        // muted = whether muted is turned on or not
        if (muted === true) {
          vimplayer.setMuted(false);
        } else {
          vimplayer.setMuted(true);
          manuallyMuted = true;
        }
      }).catch(function (error) {
        // an error occurred
        console.log(error);
      });
    }



    function changePause() {
      console.log('clicked pause/play button');

      vimplayer.getPaused().then(function (paused) {
        if (paused === true) {  // if paused
          vimplayer.play();
        } else {  // if not paused
          vimplayer.pause();
        }
      }).catch(function (error) {
        // an error occurred
        console.log(error);
      });
    }



    let idx = 0;
    let progress;

    function playbackProgress() {
      // console.log('playbackProgress');
      progress = setInterval(intervalAction, 1000);

      async function intervalAction() {
        // console.log('idx', idx);
        // console.log('notPaused()', await notPaused());
        if (await !!vimplayer.getPaused()) //  && idx < 10
        {
          // update line
          idx++;
          updatePlaybackLine();
        } else {
          console.log('DONE clearInterval');
          clearInterval(progress);
        }
      }

    }


    playbackProgress();


    function updatePlaybackLine() {
      vimplayer.getCurrentTime().then(function (seconds) {
        // seconds = the current playback position
        // console.log('current secs: ', seconds);
        // console.log('videoDuration: ', videoDuration);
        const lineWidth = (100 / videoDuration * seconds) / 100;
        // console.log('line width: ', lineWidth, videoDuration, seconds);
        const lineEl = document.querySelector('.playback__line')
        lineEl.style.backgroundColor = 'grey';
        // lineEl.style.width = lineWidth + '%';
        lineEl.style.scale = lineWidth + ' 1';
      }).catch(function (error) {
        // an error occurred
        console.log(error);
      });
    }



    vimeoReady();
    async function vimeoReady() {

      // test if vimplayer is available
      await vimplayer.getDuration()
        .catch(err => console.error(err));

      if (initiallyPauseVideo === 'True') {  // CMS returns strings "True" or "False"
        console.log('pause video', initiallyPauseVideo);
        vimplayer.pause();  // pause video
        console.log('unMute video');
        vimplayer.setMuted(false);  // unmute video
      }
    }


  }

}


async function waitForVariable(variableFunction, interval = 100) {
  return new Promise((resolve) => {
    const checkVariable = setInterval(() => {
      if (variableFunction()) {
        clearInterval(checkVariable);
        resolve();
      }
    }, interval);
  });
}
